module.exports = __webpack_public_path__ + "img/charme_black_ba_list.984a63fd.jpg";